import React from 'react'

type Props = {
  fill?: string
  className?: string
}

const CuttingZonesIcon: React.FC<Props> = ({ className, fill = '#ffffff' }) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill={fill}
    className={className}
  >
    <defs>
      <path
        id="cuttingZonesIcon"
        d="M14.788 20.41c.229-.015.465.033.682.156a1.16 1.16 0 0 1 .44 1.61 1.202 1.202 0 0 1-1.637.432 1.16 1.16 0 0 1-.44-1.61c.21-.355.573-.562.955-.588zm-9.575 0c.382.026.744.233.953.589a1.16 1.16 0 0 1-.44 1.609 1.201 1.201 0 0 1-1.635-.433 1.16 1.16 0 0 1 .439-1.609c.217-.123.453-.171.683-.156zm9.724-1.177c-.85-.02-1.69.408-2.141 1.177-.658 1.12-.26 2.572.879 3.218 1.138.646 2.615.255 3.273-.864.657-1.12.26-2.571-.88-3.218a2.406 2.406 0 0 0-1.13-.313zm-9.874 0c-.386.01-.776.111-1.132.313-1.138.647-1.536 2.098-.879 3.218.658 1.12 2.134 1.51 3.273.864 1.139-.646 1.537-2.098.88-3.218a2.417 2.417 0 0 0-2.142-1.177zM7.41 13.59L5.278 17.21c-1.603-.049-3.186.715-4.04 2.17-1.235 2.104-.495 4.816 1.646 6.03 2.14 1.216 4.898.487 6.134-1.617.855-1.456.734-3.182-.112-4.524.306-.52.61-1.042.916-1.563-.23-.39-.453-.786-.682-1.177l-1.43 2.437c-.12.199-.105.468.037.652a3.192 3.192 0 0 1 .233 3.586c-.912 1.554-2.917 2.083-4.497 1.186-1.58-.897-2.12-2.868-1.207-4.422a3.324 3.324 0 0 1 3.282-1.6.617.617 0 0 0 .59-.285l1.954-3.319-.692-1.177zM10 12.402a.593.593 0 0 0-.598.589c0 .325.267.588.598.588.33 0 .598-.263.598-.588a.593.593 0 0 0-.598-.589zM4.053 1.397l9.8 16.687c.117.196.359.313.588.285a3.325 3.325 0 0 1 3.283 1.6c.912 1.554.374 3.525-1.207 4.422-1.58.897-3.585.368-4.497-1.186a3.193 3.193 0 0 1 .234-3.586.595.595 0 0 0 .037-.652C9.491 14.213 6.71 9.434 3.903 4.68c-.17-.287-.322-1.191-.243-1.996.06-.463.142-.956.393-1.287zM15.863 0c-.327.02-.51.161-.71.404-1.67 2.816-3.326 5.651-4.985 8.477l.692 1.177 5.087-8.66c.271.331.352.886.393 1.286.079.805-.073 1.709-.243 1.996-1.403 2.377-2.802 4.76-4.2 7.143l.684 1.168a2827.14 2827.14 0 0 1 4.544-7.723c.434-.728.508-1.723.412-2.703a4.981 4.981 0 0 0-.328-1.397C16.868.513 16.566.06 15.863 0zM4.016 0c-.617.077-1.03.702-1.225 1.168a5.002 5.002 0 0 0-.328 1.397c-.096.98-.022 1.975.412 2.703 2.747 4.656 5.474 9.34 8.219 14.002-.846 1.342-.967 3.068-.112 4.524 1.236 2.104 3.993 2.833 6.134 1.618 2.14-1.215 2.881-3.927 1.646-6.031-.854-1.455-2.437-2.219-4.04-2.17C11.391 11.633 8.202 5.965 4.848.404 4.593.104 4.333.041 4.016 0z"
      />
    </defs>
    <use
      fill="inherit"
      fillRule="evenodd"
      transform="translate(3)"
      xlinkHref="#cuttingZonesIcon"
    />
  </svg>
)

export default CuttingZonesIcon
